import React from 'react';
import { Link } from 'react-router';
import { useDebriefRouter } from 'ff/debrief/hooks';
import styled from 'styled-components';
import * as API from 'ff/debrief/features/TracklogApi';

interface Props {
    tracklogId?: string;
    shareId?: string;
    onClick?: () => void;
}

const LinkToHome = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren<Props>
>(function LinkToTracklog(props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { tracklogId, shareId, ...rest } = props;
    const tracklogsQuery = API.useGetAllTracklogsQuery({ page: 0 });
    const firstItem = tracklogsQuery.data && tracklogsQuery.data.tracklogs[0];
    const { getTracklogRouteString } = useDebriefRouter();
    const pathString = getTracklogRouteString(
        tracklogId || firstItem?.trackUuid
    );
    if (pathString)
        return (
            <UnstyledLink ref={ref} to={pathString} {...rest}>
                {props.children}
            </UnstyledLink>
        );
    else return null;
});

const UnstyledLink = styled(Link)`
    text-decoration: inherit;
    color: inherit;
`;

export default LinkToHome;
